import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { QueryClient } from "@tanstack/react-query";

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
	applyAuth?: boolean;
}

// ==================
//  User Service API
// ==================
export const userServiceAPI: AxiosInstance = axios.create({
	baseURL: /*'http://localhost:4001/api/v0',*/ 'https://bi-dev-user-service.azurewebsites.net/api/v0',
});
userServiceAPI.interceptors.request.use(
	(config: any) => {
		const token = localStorage.getItem('access_token');
		if (token && config.applyAuth !== false) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// ==================
//  Application Service API
// ==================
export const applicationServiceAPI: AxiosInstance = axios.create({
	baseURL: /*'http://localhost:4002/api/v0',*/ 'https://bi-dev-application-service.azurewebsites.net/api/v0',
});
applicationServiceAPI.interceptors.request.use(
	(config: any) => {
		const token = localStorage.getItem('access_token');
		if (token && config.applyAuth !== false) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
